import { toast } from 'react-toastify';
import * as ActionTypes from '../../constants/actiontypes/backoffice/clients';
import * as ActionTypesAuth from '../../constants/actiontypes/auth';
import * as ActionTypesUser from '../../constants/actiontypes/user';
import * as Loadings from '../../constants/loadings/backoffice/clients';
import * as LoadingsUser from '../../constants/loadings/user';
import * as R from 'ramda';
import User from '../../constants/models/user';
import BackofficeUser from '../../constants/models/backofficeUser';
import * as TextUser from '../../constants/toasterText/user';
import * as TextClient from '../../constants/toasterText/backofficeClients';
import { pageLimit } from '../../constants/paginations/paginationLimit';

const toastConf = { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 };

const ClientsReducer = (state = {
    isLoading: [],
    clients: undefined,
    allClientsData: undefined,
    isDeletingClient: false,
    resetPasswordPhoneNumber: false,
    nextPage: true,
    totalPages: 0,
    totalRecords: 0,
    currentPage: 0,
    globalFilters: {
        order: {
            column: "lastName",
            asc: false
        },
        role: undefined,
        search: "",
    }


}, action) => {
    switch (action.type) {

        case ActionTypes.FETCH_CLIENTS_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_CLIENTS)) {
                state.isLoading = state.isLoading.concat(Loadings.FETCHING_CLIENTS);
            }

            return { ...state };

        case ActionTypes.FETCH_ALL_CLIENTS_DATA_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_ALL_CLIENTS_DATA)) {
                state.isLoading = state.isLoading.concat(Loadings.FETCHING_ALL_CLIENTS_DATA);
            }
            return { ...state };

        case ActionTypes.FETCH_ALL_CLIENTS_DATA_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_ALL_CLIENTS_DATA);
            state.allClientsData = action.data.items.map(l => new BackofficeUser(l));
            return { ...state };

        case ActionTypes.FETCH_ALL_CLIENTS_DATA_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_ALL_CLIENTS_DATA);
            return { ...state };

        case ActionTypes.FETCH_CLIENTS_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_CLIENTS);

            //action.data.length < pageLimit
            if ((action.data.pageNumber + 1) === action.data.totalPages) {
                state.nextPage = false;
            } else {
                state.nextPage = true;
            }

            if (state.clients) {
                const moreClients = action.data.items.map(user => new BackofficeUser(user));
                state.clients = [...moreClients];
            } else {

                state.clients = action.data.items.map(user => new BackofficeUser(user));
            }
            state.totalPages = action.data.totalPages;
            state.totalRecords = action.data.totalRecords;
            state.currentPage = action.data.pageNumber + 1;

            return { ...state };

        case ActionTypes.FETCH_CLIENTS_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_CLIENTS);
            return { ...state };

        case ActionTypes.DELETE_CLIENT_REQUEST:
            state.isDeletingClient = true;
            return { ...state };

        case ActionTypes.DELETE_CLIENT_SUCCESS:
            state.isDeletingReferent = false;
            state.clients = state.clients.filter(c => c.id !== action.user.id);
            toast.success(TextClient.clientDeleteSuccess, toastConf);
            return { ...state };

        case ActionTypes.DELETE_CLIENT_FAILURE:
            state.isDeletingReferent = false;
            toast.error(TextClient.clientDeleteFailed, toastConf);
            return { ...state };

        case ActionTypesAuth.RESET_PASSWORD_SUCCESS:
            state.resetPasswordPhoneNumber = true;
            toast.success(TextClient.emailPasswordRecoveredSucess, toastConf);
            return { ...state };

        case ActionTypesAuth.RESET_PASSWORD_FAILURE:
            state.resetPasswordPhoneNumber = false;
            toast.error(TextClient.emailPasswordRecoveredFailed, toastConf);
            return { ...state };

        case ActionTypes.UPDATE_CLIENT_REQUEST:
            if (!state.isLoading.includes(LoadingsUser.UPDATE_USER)) {
                state.isLoading = state.isLoading.concat(LoadingsUser.UPDATE_USER);
            }
            return { ...state };

        case ActionTypes.UPDATE_CLIENT_SUCCESS:
            state.clients = state.clients.map((client) => {
                if (client.id === action.userId) {
                    client.isEnabled = action.user.isEnabled;
                    return client;
                }
                return client;
            });

            state.isLoading = state.isLoading.filter(l => l !== LoadingsUser.UPDATE_USER);
            toast.success(TextUser.dataUpdatedSuccess, toastConf);
            return { ...state };

        case ActionTypes.UPDATE_CLIENT_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== LoadingsUser.UPDATE_USER);
            toast.error(TextUser.dataUpdateFailed, toastConf);
            return { ...state };

        case ActionTypes.UPDATE_CLIENT_SECURITY_REQUEST:
            if (!state.isLoading.includes(LoadingsUser.UPDATE_SECURITY)) {
                state.isLoading = state.isLoading.concat(LoadingsUser.UPDATE_SECURITY);
            }
            return { ...state };

        case ActionTypes.UPDATE_CLIENT_SECURITY_SUCCESS:
            if (!R.isNil(action.user.newPhoneNumber)) {
                //state.user.phoneNumber = action.user.newPhoneNumber;
                // sessionStorage.removeItem("access_token");
                // window.location = "/auth/signin";
                state.clients = state.clients.map((client) => {
                    if (client.id === action.userId) {
                        client.phoneNumber = action.user.newPhoneNumber;
                        return client;
                    }
                    return client;
                });

            }
            if (!R.isNil(action.user.newEmail)) {
                state.clients = state.clients.map((client) => {
                    if (client.id === action.userId) {
                        client.email = action.user.newEmail;
                        return client;
                    }
                    return client;
                });

            }

            state.isLoading = state.isLoading.filter(c => c !== LoadingsUser.UPDATE_SECURITY);
            toast.success(TextUser.updateSecuritySuccess, toastConf);
            return { ...state };

        case ActionTypes.UPDATE_CLIENT_SECURITY_FAILURE:
            state.isLoading = state.isLoading.filter(c => c !== LoadingsUser.UPDATE_SECURITY);
            toast.error(TextUser.udpateSecurityFailed, toastConf);
            return { ...state };


        case ActionTypes.SET_CLIENT_FILTER:
            const newState = { ...state.globalFilters, ...action.data };
            state.globalFilters = newState;
            return { ...state };

        default:
            return state;
    }
};
export default ClientsReducer;